var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7083 7.05021L5.95825 3.15771",
    stroke: "#8E8E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0833 11.9999V5.99993C16.083 5.73688 16.0135 5.47853 15.8819 5.2508C15.7503 5.02306 15.5611 4.83395 15.3333 4.70243L10.0833 1.70243C9.85522 1.57077 9.59656 1.50146 9.33325 1.50146C9.06995 1.50146 8.81128 1.57077 8.58325 1.70243L3.33325 4.70243C3.10545 4.83395 2.91624 5.02306 2.7846 5.2508C2.65296 5.47853 2.58352 5.73688 2.58325 5.99993V11.9999C2.58352 12.263 2.65296 12.5213 2.7846 12.7491C2.91624 12.9768 3.10545 13.1659 3.33325 13.2974L8.58325 16.2974C8.81128 16.4291 9.06995 16.4984 9.33325 16.4984C9.59656 16.4984 9.85522 16.4291 10.0833 16.2974L15.3333 13.2974C15.5611 13.1659 15.7503 12.9768 15.8819 12.7491C16.0135 12.5213 16.083 12.263 16.0833 11.9999Z",
    stroke: "#8E8E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.78564 5.22021L9.33314 9.00771L15.8806 5.22021",
    stroke: "#8E8E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33325 16.56V9",
    stroke: "#8E8E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIcon);
export default __webpack_public_path__ + "static/media/product-icon.dd8958cd007b3d7ea7320c675d7f5a6e.svg";
export { ForwardRef as ReactComponent };